var globalContainerApp = null;

class ContainerApp {

  firstLoaded = false;
  alreadyEvaluated = false;
  containerSharedOrNot = false;
  _HEAVY_OBJECT_ = 980;
  _MAX_CONTAINER_WEIGHT_ = 20000;
  // _HEAVY_WEIGHT_LIMIT_ = 16000;
  _HEAVY_WEIGHT_LIMIT_ = 160000;
  // _HEAVY_WARNING_ = 12000;
  _HEAVY_WARNING_ = 120000;
  userDisabled = true;
  isSharedContainer = false;
  swappingContainers = false;
  locateAndDisableNonCompatibleProductsInterval = null;

  domElements = {
    cartHeaderIcon: null,
    addToCartButton: null,
    addToCartForm: null,
    configureContainerOverlay: null,
    confirmContainerOverlayButton: null,
    configureContainerCloseButton: null,
    addToCartText: null,
    addToCartSpinner: null,
    loginButton: null,
    errorContainer: null,
    css: null,
    withHoles: null,
    withoutHoles: null,

    //New container modal
    availableContainers: null,
    selectContainerType: null,
    shareabilityContainer: null,
    buttonSharedContainer: null,
    buttonOwnContainer: null,

    //Overfill modal
    overfillModal: null,
    overfillModalMessageSize: null,
    overfillModalMessageWeight: null,
    overfillModalOkbutton: null,
    overfillModalBackbutton: null,
    overfillModalClosebutton: null,

    //Completed modal
    completedModal: null,
    completedModalOkbutton: null,
    completedModalBackbutton: null,
    completedModalClosebutton: null
  };

  containerPercentage = 0;
  containerOverWeight = false;
  containerWeightDisproportionate = false;
  containerTotalWeight = 0;
  isContainerFull = false;
  isContainerAlmostFull = false;
  customerId = null;
  shop = "ch-oon.myshopify.com";
  domContainer = null;
  productVendorCode = null;
  withHoles = true;

  // endpoint = {
  //   getActiveContainers: `${_ENDPOINT_}/container/all`,
  //   containerSingleStatus: `${_ENDPOINT_}/container/single/status`,
  //   containerSharedStatus: `${_ENDPOINT_}/container/shared/status`,
  //   containerRegister: `${_ENDPOINT_}/container/register`,
  //   containerSwap: `${_ENDPOINT_}/container/register/multi`,
  //   getAvailableContainers: `${_ENDPOINT_}/container/search`,
  //   addToContainer: `${_ENDPOINT_}/container/evaluate`,
  //   purgeCapacityCache: `${_ENDPOINT_}/container/status/cache/invalidate`,
  //   containerAcceptInvitation: `${_ENDPOINT_}/container/register/shared`,
  //   containerLeave: `${_ENDPOINT_}/container/leave`,
  //   uploadLabel: `${_ENDPOINT_}/order/label/upload`,
  //   variantSwap: `${_ENDPOINT_}/container/variation/get`,
  //   customerAddresses: `${_ENDPOINT_}/customer/addresses`,
  //   setLinkAddress: `${_ENDPOINT_}/container/addresses`
  // };

  endpoint = {
    getActiveContainers: `https://choon.duckdns.org/container/all`,
    containerSingleStatus: `https://choon.duckdns.org/container/single/status`,
    containerSharedStatus: `https://choon.duckdns.org/container/shared/status`,
    containerRegister: `https://choon.duckdns.org/container/register`,
    containerSwap: `https://choon.duckdns.org/container/register/multi`,
    getAvailableContainers: `https://choon.duckdns.org/container/search`,
    addToContainer: `https://choon.duckdns.org/container/evaluate`,
    purgeCapacityCache: `https://choon.duckdns.org/container/status/cache/invalidate`,
    containerAcceptInvitation: `https://choon.duckdns.org/container/register/shared`,
    containerLeave: `https://choon.duckdns.org/container/leave`,
    uploadLabel: `https://choon.duckdns.org/order/label/upload`,
    variantSwap: `https://choon.duckdns.org/container/variation/get`,
    customerAddresses: `https://choon.duckdns.org/customer/addresses`,
    setLinkAddress: `https://choon.duckdns.org/container/addresses`
  };

  appContainer = {
    containerId: null,
    containerObject: null
  };

  cartContainer = document.getElementById("Cart");
  cartObject = null;

  constructor() {
    this.domContainer = document.querySelector("#container-app");
    if (!this.domContainer) {
      // Container app DOM not found, skip initialization
      return;
    }
    this.productVendorCode = this.domContainer.getAttribute('data-product-provider-code');
    this.customerId = this.domContainer.getAttribute("data-customer-id");
    this.userDisabled = this.domContainer.getAttribute('data-customer-tags')?.toString().includes('DISABLED') || false;
    this.inflateDomElements();
    // DISABLED: Header container indicators removed
    // this.boostrapHeader();
    this.boostrapProductPageActions();

    // DISABLED: Periodic cart/container status checks removed
    // this.getCartContents();
    // window.setInterval(() => {
    //   this.getCartContents();
    // }, 3000);
  }

  /**
   * Inflates all the dom elements
   */
  inflateDomElements() {
    this.domElements.cartHeaderIcon = document.querySelector(".thb-secondary-area-item.thb-secondary-cart");
    this.domElements.configureContainerCloseButton = document.querySelector(".appcontainer-close");
    this.domElements.css = document.querySelector('#multicontainer-hidder');
    this.domElements.configureContainerOverlay = document.querySelector(".appcontainer-overlay");
    this.domElements.confirmContainerOverlayButton = document.querySelector("#container-continue-btn");
    this.domElements.addToCartButton = document.querySelector("#container-buy-btn");
    this.domElements.addToCartText = document.querySelector("#adt-text");
    this.domElements.addToCartSpinner = document.querySelector("#adt-spinner");
    this.domElements.loginButton = document.querySelector("#container-login-btn");
    this.domElements.errorContainer = document.querySelector("#cnt-error-container");
    this.domElements.withHoles = document.querySelector(".with-holes");
    this.domElements.withoutHoles = document.querySelector(".without-holes");

    //New container modal
    this.domElements.availableContainers = document.querySelector("#containers-available");
    this.domElements.selectContainerType = document.querySelector(".appcontainer-provider-type");
    this.domElements.buttonSharedContainer = document.querySelector("#shared_container_btn");
    this.domElements.shareabilityContainer = document.querySelector(".new-container-share-block");
    this.domElements.buttonOwnContainer = document.querySelector("#own_container_btn");
    this.domElements.dateContainer = document.querySelector("#container_datechooser");
    this.domElements.dateInput = document.querySelector("#container_date");

    //Overfill container modal
    this.domElements.overfillModal = document.querySelector(".appcontainer-overfill-overlay");
    this.domElements.overfillModalMessageWeight = document.querySelector(".appcontainer-overfill-msg-weight");
    this.domElements.overfillModalMessageSize = document.querySelector(".appcontainer-overfill-msg-size");
    this.domElements.overfillModalBackbutton = document.querySelector("#container-overfill-ok");
    this.domElements.overfillModalOkbutton = document.querySelector("#container-overfill-back");
    this.domElements.overfillModalClosebutton = document.querySelector(".appcontainer-overfill-close");

    //Completed container modal
    this.domElements.completedModal = document.querySelector(".appcontainer-completed-overlay");
    this.domElements.completedModalBackbutton = document.querySelector("#container-completed-ok");
    this.domElements.completedModalOkbutton = document.querySelector("#container-completed-back");
    this.domElements.completedModalClosebutton = document.querySelector(".appcontainer-completed-close");

    //Add overfill listeners
    this.domElements.overfillModalBackbutton.addEventListener("click", () => {
      window.history.back();
    });
    //The overfill modal ok button handler
    this.domElements.overfillModalOkbutton.addEventListener("click", () => {
      window.location.href = "/cart";
    });
    //Same, but for close button
    this.domElements.overfillModalClosebutton.addEventListener("click", () => {
      this.domElements.overfillModal.style.display = "none";
    });

    //Add completed modal button listeners
    this.domElements.completedModalBackbutton.addEventListener('click', () => {
      window.location.href = "/cart";
    });
    this.domElements.completedModalOkbutton.addEventListener('click', () => {
      this.addNewContainerToCustomer();
    });
    this.domElements.completedModalClosebutton.addEventListener('click', () => {
      this.domElements.completedModal.style.display = "none";
    });

    //Add fixed listeners
    this.domElements.configureContainerCloseButton.addEventListener("click", () => {
      this.domElements.configureContainerOverlay.style.display = "none";
    });

    //with or without holes listeners toggle
    if (typeof this.domElements.withHoles != "undefined" && this.domElements.withHoles != null) {
      this.domElements.withHoles.addEventListener("click", () => {
        this.domElements.withoutHoles.classList.remove("active");
        this.domElements.withHoles.classList.add("active");
        this.withHoles = true;
      });
    }
    if (typeof this.domElements.withoutHoles != "undefined" && this.domElements.withoutHoles != null) {
      this.domElements.withoutHoles.addEventListener("click", () => {
        this.domElements.withHoles.classList.remove("active");
        this.domElements.withoutHoles.classList.add("active");
        this.withHoles = false;
      });
    }

    //The both toggles for the container type
    this.domElements.buttonOwnContainer.addEventListener("click", () => {
      this.containerSharedOrNot = false;

      this.domElements.buttonOwnContainer.classList.add("active");
      this.domElements.buttonSharedContainer.classList.remove("active");
      this.domElements.dateContainer.style.display = 'none';

    });
    this.domElements.buttonSharedContainer.addEventListener("click", () => {
      this.containerSharedOrNot = true;

      this.domElements.buttonOwnContainer.classList.remove("active");
      this.domElements.buttonSharedContainer.classList.add("active");
      this.domElements.dateContainer.style.display = 'block';
    });

    /**
     * The add new container to customer event
     */
    this.domElements.confirmContainerOverlayButton.addEventListener("click", async (e) => {
      let containerDateLimit = this.domElements.dateInput.value;
      if (this.containerSharedOrNot) {
        if (containerDateLimit == null) {
          alert("Debe seleccionar una fecha para continuar");
          return;
        }

        if (containerDateLimit.toString().length < 4) {
          alert("Debe seleccionar una fecha para continuar");
          return;
        }

        //Get today date
        let today = new Date();
        //Now, create a date object based on containerDateLimit
        let containerDateLimitObject = new Date(containerDateLimit);
        //Check if containerDateLimitObject is later (in the future) than today date
        if (containerDateLimitObject <= today) {
          alert("La fecha límite del contenedor debe ocurrir en el futuro");
          return;
        }
      }

      let registerEndpoint = null;
      //Determine if we're swapping containers (not closing current one but opening a new one) or just creating a new one
      if (this.swappingContainers) {
        registerEndpoint = this.endpoint.containerSwap;
      } else {
        registerEndpoint = this.endpoint.containerRegister;
      }
      //Submit the container configuration to the remote server and close the modal
      let response = await fetch(registerEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          shop: this.shop,
          containerId: parseInt(this.selectedContainer),
          shared: this.containerSharedOrNot,
          containerType: this.domElements.selectContainerType.value,
          userId: this.customerId,
          containerDateLimit: containerDateLimit,
          joining: false,
          cart: this.cartObject
        })
      });
      let decodedResponse = await response.json();
      if (decodedResponse.code == 200) {
        //Hide the modal
        this.domElements.configureContainerOverlay.style.display = "none";

        //Store / update the cart note contents
        let orderNote = null;
        //Logic: if we're swapping containers, means we already have some data setted into the container, so we need to append
        //the new link and container id to the existing note
        if (this.swappingContainers) {
          orderNote = JSON.parse(this.cartObject.note);
        }
        if (orderNote != null) {
          if (!orderNote.hasOwnProperty('links')) {
            orderNote.links = [];
          }
          if (!Array.isArray(orderNote.links)) {
            orderNote.links = [];
          }
          orderNote.links.push(decodedResponse.userContainerLink);
        } else {
          orderNote = {
            links: [decodedResponse.userContainerLink]
          };
        }
        //Update the cart with the note
        await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ note: JSON.stringify(orderNote) })
        });

        //After processing a container register, always set this to false
        this.swappingContainers = false;


        console.log("Container created successfully:", decodedResponse);

        // Actualizar los datos del contenedor antes de añadir el producto
        this.appContainer = {
          linkId: decodedResponse.userContainerLink,
          containerId: decodedResponse.containerId,
          userContainerId: decodedResponse.userContainerId,
          containerObject: null // Will be populated on next getContainerStatus call
        };

        console.log("Updated container data:", this.appContainer);

        // Actualizar el estado del contenedor antes de intentar añadir el producto
        await this.getCartContents();

        console.log("Cart contents refreshed, container status updated");

        // Si estamos en una página de producto, intentar añadir el producto actual
        if (typeof lgGlobalContainersProductId !== 'undefined' && typeof lgGlobalContainersVariantId !== 'undefined') {
          try {
            // Mostrar spinner o indicador de carga
            if (this.domElements.addToCartText && this.domElements.addToCartSpinner) {
              this.domElements.addToCartText.style.display = "none";
              this.domElements.addToCartSpinner.style.display = "block";
            }
            console.log("Calling addProductToContainer");
            // Añadir el producto al contenedor
            const addResult = await this.addProductToContainer(
              lgGlobalContainersProductId,
              lgGlobalContainersVariantId
            );
            console.log("Add product result:", await addResult);
            // Ocultar spinner
            if (this.domElements.addToCartText && this.domElements.addToCartSpinner) {
              this.domElements.addToCartText.style.display = "block";
              this.domElements.addToCartSpinner.style.display = "none";
            }

            // Si se añadió correctamente, mostrar el carrito
            if (addResult.status) {
              // Refrescar el carrito
              await this.getCartContents();
              // Refrescar el drawer del carrito si existe
              if (typeof globalCartDrawer !== 'undefined') {
                globalCartDrawer.refresh();
              }
              // Abrir el carrito
              const cartButton = document.querySelector(".thb-secondary-cart");
              if (cartButton) {
                cartButton.click();
              }

              return
            }
          } catch (error) {
            console.error("Error al añadir el producto al contenedor:", error);
          }
        }
      }
    });
  }

  /**
   * Downloads the cart contents, then with the cart token, calls to the container status endpoint
   * DISABLED: Backend integration removed
   */
  async getCartContents() {
    return new Promise(async (resolve, reject) => {
      const cartResponse = await fetch(`/cart.js`);
      const cartResponseDecoded = await cartResponse.json();
      this.cartObject = cartResponseDecoded;

      // DISABLED: Backend container status check removed
      // this.getContainerStatus();
      resolve();
    })
  }

  /**
   * Loads the header items
   */
  boostrapHeader() {
    //add the container indicator to the cart
    if (typeof this.domElements.cartHeaderIcon != "undefined" && this.domElements.cartHeaderIcon != null) {
      this.domElements.cartHeaderIcon.innerHTML += `
        <div class="container-capacity-indicator">
            <label id="container-capacity-percentage"></label>
            <span class="container-capacity-bar" data-capacity="10"></span>
            <span class="container-capacity-bar" data-capacity="20"></span>
            <span class="container-capacity-bar" data-capacity="30"></span>
            <span class="container-capacity-bar" data-capacity="40"></span>
            <span class="container-capacity-bar" data-capacity="50"></span>
            <span class="container-capacity-bar" data-capacity="60"></span>
            <span class="container-capacity-bar" data-capacity="70"></span>
            <span class="container-capacity-bar" data-capacity="80"></span>
            <span class="container-capacity-bar" data-capacity="90"></span>
            <span class="container-capacity-bar" data-capacity="100"></span>
        </div>
    `;

      //Add the intervals to update the container percentage
      window.setTimeout(() => {
        window.setInterval(() => {
          document.querySelector("#container-capacity-percentage").innerText = `${this.containerPercentage}%`;
          let bars = document.querySelectorAll(".container-capacity-bar");
          for (let i = 0; i < bars.length; i++) {
            if (bars[i].getAttribute("data-capacity") <= this.containerPercentage) {
              bars[i].classList.add("filled");
            } else {
              bars[i].classList.remove("filled");
            }
          }
        }, 500);
      }, 1000);
    }
  }


  /**
   * Fetches the status of the container and updates the container object.
   * DISABLED: Backend integration removed
   *
   * @return {Promise<void>}
   */
  async getContainerStatus() {
    // DISABLED: Backend container status check removed
    // All backend API calls have been disabled to restore normal Shopify buying experience
    return;
  }

  /**
   * Clears the Shopify cart.
   * DISABLED: No longer automatically emptying cart - allowing normal cart behavior
   * @returns {Promise} A promise that resolves with the response of clearing the cart.
   */
  async emptyShopifyCart() {
    // DISABLED: No longer automatically emptying cart
    // const cartResponse = await fetch(`/cart/clear.js`, {
    //   method: 'POST'
    // });
    // const cartResponseDecoded = await cartResponse.json();
  }

  /**
   * Executes the evaluation to know if the pallet can be added to the container
   * DISABLED: Backend evaluation removed - allowing normal add-to-cart
   */
  async innitialEvaluate() {
    // DISABLED: Backend product evaluation removed
    // Products can now be added to cart normally without container validation
    return;
  }

  /**
   * Handles the operations on the product page
   * DISABLED: Backend integration removed - allowing normal Shopify add-to-cart
   */
  boostrapProductPageActions() {
    // DISABLED: No longer intercepting form submissions to allow normal Shopify buying experience
    // window.setTimeout(() => {
    //   this.domElements.addToCartForm = document.querySelectorAll("form[action=\"/cart/add\"]");
    //   for (let i = 0; i < this.domElements.addToCartForm.length; i++) {
    //     //Add a event listener to the add to cart form, avoid the submiting it, instead, we'll control the add to cart process
    //     this.domElements.addToCartForm[i].addEventListener("submit", (e) => {
    //       return false;
    //     });
    //   }

    //   //Add event listener to the new button
    //   if (typeof this.domElements.addToCartButton != "undefined" && this.domElements.addToCartButton != null) {
    //     this.domElements.addToCartButton.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       if (!this.userDisabled) {
    //         this.addToContainer();
    //       }
    //       return false;
    //     });
    //   }

    //   //Add event listener to the login button
    //   if (typeof this.domElements.loginButton != "undefined" && this.domElements.loginButton != null) {
    //     this.domElements.loginButton.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       //Redirect to login page
    //       location.href = `https://${Shopify.shop}/account`;
    //       return false;
    //     });
    //   }
    // }, 1000);
  }

  /**
   * Adds to the container
   */
  async addToContainer() {
    if (!this.firstLoaded) {
      return;
    }

    //First of all, check if there's a container available
    if (this.appContainer.containerId == null) {
      //ask the customer to add a container
      this.showConfigurationModal();
    } else {
      //Toggle add to cart text and spinner
      this.domElements.addToCartText.style.display = "none";
      this.domElements.addToCartSpinner.style.display = "block";

      //Get the product Id
      const productId = lgGlobalContainersProductId;
      const variantId = lgGlobalContainersVariantId;

      //Heavy product check (cannot when container is over 16T
      if (this.containerTotalWeight >= this._HEAVY_WEIGHT_LIMIT_) {
        const heavyObjectDOMElement = document.querySelector("#cnt-heavy-product-notification");
        if (heavyObjectDOMElement != null && typeof heavyObjectDOMElement != "undefined") {
          //Then is heavy and the container is heavy too, block the add to cart
          this.domElements.overfillModal.style.display = "block";
          this.domElements.overfillModalMessageWeight.style.display = "block";
          this.domElements.overfillModalMessageSize.style.display = "none";
          return;
        }
      }

      //Add the product to the container
      const adtResponse = await this.addProductToContainer(productId, variantId);
      if (adtResponse.status) {
        //Refresh the cart
        this.getCartContents();
        //Refresh the cart drawer contents
        globalCartDrawer.refresh();
        //Trigger a click on the cart to open it.
        document.querySelector(".thb-secondary-cart").click();
      } else {
        if (!adtResponse.compatibility.size) {
          //Special behaviour for size compatibility issues.
          this.domElements.overfillModal.style.display = "block";
          this.domElements.overfillModalMessageWeight.style.display = "none";
          this.domElements.overfillModalMessageSize.style.display = "block";
        } else {
          //First, empty the errors
          this.domElements.errorContainer.innerHTML = "";
          //Print one error for each error in the array response
          for (const error of adtResponse.errors) {
            this.domElements.errorContainer.innerHTML += `<div class="error-item"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg> ${error}</div>`;
          }
          //check if the container is not balanced (weight vs capacity)
          if (this.containerWeightDisproportionate) {
            this.domElements.errorContainer.innerHTML += `<div class="error-item"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg> El contenedor está descompensado, el contenedor es demasiado pesado para lo lleno que está, por favor, agregue elementos ligeros para poder completar su contenedor.</div>`;
          }
        }
      }

      //Toggle add to cart text and spinner
      this.domElements.addToCartText.style.display = "block";
      this.domElements.addToCartSpinner.style.display = "none";
    }
  }


  /**
   * Evaluates if a given product can be added to the current container and adds it to the container
   * DISABLED: Backend integration removed - this function no longer works
   * @returns {Promise<void>}
   */
  async addProductToContainer(productId, variantId, quantity = null, onlyEvaluate = false) {
    // DISABLED: Backend product evaluation and container logic removed
    // Return success to prevent errors, but actual add-to-cart should use normal Shopify flow
    return new Promise(async (resolve, reject) => {
      resolve({
        status: false,
        errorLog: ['Container system disabled - use normal add to cart'],
        compatibility: null
      });
    });
  }


  /**
   * Invalidates the cache for the specified customer.
   * DISABLED: Backend cache invalidation removed
   *
   * @return {Promise<void>} A Promise that resolves when the cache is successfully invalidated.
   */
  async invalidateCache() {
    // DISABLED: Backend cache invalidation removed
    // await fetch(`${this.endpoint.purgeCapacityCache}?customerId=${this.customerId}`);
  }

  /**
   * This function will remove from the cart using the provided url, then will invaldiate the cache
   * @returns {Promise<void>}
   */
  async removeItemFromCart(url, context) {
    await fetch(url);
    this.invalidateCache();
    if (context != null) {
      context.parentNode.parentNode.remove();
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then((cartResponse) => cartResponse.json())
      .then((cartData) => {
        if (cartData.item_count === 0) {
          this.leaveContainerPopup();
        }
      });
  }

  /**
   * Opens the configuration modal
   * DISABLED: Backend container configuration removed
   */
  async showConfigurationModal() {
    // DISABLED: Backend container configuration removed
    // Modal will not function without backend
    return;
    // All code below is disabled - backend integration removed
    /*
    let selectedContainer = null;
    let containersAvailableResponse = await fetch(`${this.endpoint.getAvailableContainers}?shop=${this.shop}&vendorCode=${this.productVendorCode}`);
    let availableContainers = await containersAvailableResponse.json();

    console.log(availableContainers);

    this.domElements.availableContainers.innerHTML = "";

    // Check if containers are available
    if (!availableContainers.containers || availableContainers.containers.length === 0) {
      this.domElements.availableContainers.innerHTML = `
        <div class="no-containers-message">
          <p>No hay contenedores disponibles en este momento.</p>
        </div>
      `;
      // Disable the continue button
      if (this.domElements.confirmContainerOverlayButton) {
        this.domElements.confirmContainerOverlayButton.disabled = true;
        this.domElements.confirmContainerOverlayButton.classList.add('disabled');
      }
    } else {
      // Enable the continue button if it was disabled
      if (this.domElements.confirmContainerOverlayButton) {
        this.domElements.confirmContainerOverlayButton.disabled = false;
        this.domElements.confirmContainerOverlayButton.classList.remove('disabled');
      }

      // Create the items
      for (let i = 0; i < availableContainers.containers.length; i++) {
        this.domElements.availableContainers.innerHTML += `
          <div class="container-block select-block ${i == 0 ? "active" : ""}" data-container-id="${availableContainers.containers[i].id}">
            <label>${availableContainers.containers[i].name}</label>
          </div>
        `;

        // Pre-select the first container
        if (i == 0) {
          this.selectedContainer = availableContainers.containers[0].id;
        }
      }

      // Show the manufacturers available
      this.domElements.selectContainerType.innerHTML = ""; // Clear previous options
      for (let i = 0; i < availableContainers.containers.length; i++) {
        this.domElements.selectContainerType.innerHTML += `
          <option value="${availableContainers.containers[i].vendorName.replace(" ", "_")}">${availableContainers.containers[i].vendorName}</option>
        `;
      }
    }

    // Now, add the listeners
    window.setTimeout(() => {
      let cBlocks = document.querySelectorAll(".container-block");
      for (let i = 0; i < cBlocks.length; i++) {
        cBlocks[i].addEventListener("click", (event) => {
          for (let b = 0; b < cBlocks.length; b++) {
            cBlocks[b].classList.remove("active");
          }
          cBlocks[i].classList.add("active");
          this.selectedContainer = cBlocks[i].getAttribute("data-container-id");
        });
      }
    }, 600);

    // Hide or show the shareability options
    if (this.swappingContainers) {
      this.domElements.shareabilityContainer.style.display = 'none';
    } else {
      this.domElements.shareabilityContainer.style.display = 'block';
    }

    this.domElements.configureContainerOverlay.style.display = "block";
    */
  }


  /**
   * Locates and disables non-compatible products.
   * DISABLED: Backend product compatibility checking removed
   *
   * @return {Promise} Resolves when the locating and disabling process has been completed.
   */
  async locateAndDisableNonCompatibleProducts() {
    // DISABLED: Backend product compatibility checking removed
    // Products are no longer disabled based on container compatibility
    return;
  };

  /**
   * Retrieve all containers for a customer.
   * DISABLED: Backend integration removed
   *
   * @async
   * @returns {Promise<Array>} A promise that resolves to an array of containers for the customer.
   */
  async getContainersForCustomer() {
    // DISABLED: Backend container retrieval removed
    return new Promise(async (resolve, reject) => {
      resolve([]);
    });
  };


  /**
   * Accepts an invitation from a user container.
   * DISABLED: Backend integration removed
   *
   * @param {number} userContainerId - The ID of the user container.
   * @return {Promise} - A promise that resolves when the invitation is accepted or rejects with an error.
   */
  async acceptInvitationFromContainer(userContainerId) {
    // DISABLED: Backend container invitation system removed
    return new Promise(async (resolve, reject) => {
      alert("Container system disabled - use normal buying experience");
      resolve();
    });
  }


  /**
   * Abandons the current container and empties the cart, if confirmed by the user.
   * DISABLED: Backend integration removed
   *
   * @returns {void}
   */
  async leaveContainer() {
    // DISABLED: Backend container leaving removed
    // if (confirm('¿Desea abandonar el actual contenedor? Esto provocará la pérdida de su carrito actual')) {
    //   const response = await fetch(this.endpoint.containerLeave, {
    //     method: 'POST',
    //     body: JSON.stringify({
    //       userId: this.customerId,
    //       shop: this.shop
    //     })
    //   });

    //   const decodedResponse = await response.json();

    //   //If ok empty the cart
    //   if (decodedResponse.code == 200) {
    //     this.emptyShopifyCart();
    //     //Now, go to homepage
    //     window.location.href = 'https://ch-oon.com/';
    //   } else {
    //     alert("Error abandonando el carrito, por favor, póngase en contacto con Ch-oon");
    //   }
    // }
  }

  async leaveContainerPopup() {
    // DISABLED: Backend container leaving popup removed
    // Container system is disabled, this popup will not appear
    return;
  }
  async leaveContainerError() {
    // DISABLED: Backend container error handling removed
    // Container system is disabled, this error modal will not appear
    return;
  }

  /**
   * Shows the container complete congrats modal
   */
  showCompletedModal() {
    this.domElements.completedModal.style.display = 'block';
  }


  /**
   * Set swappingContainers to true and display the configureContainerOverlay.
   */
  addNewContainerToCustomer() {
    this.domElements.completedModal.style.display = 'none';
    this.swappingContainers = true;
    this.showConfigurationModal();
  }
}

/**
 * Bootstrap the app
 */
window.setTimeout(() => {
  globalContainerApp = new ContainerApp();
}, 500);
